import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BookOpen, Key, Keyboard, Zap } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Card, CardDescription, CardHeader, CardTitle } from "~/components/ui/card";
import { $updateOnboardingStep } from "~/lib/onboarding/mutations";

function WelcomeScreen() {
  const navigate = useNavigate();

  const handleGetStarted = async () => {
    await $updateOnboardingStep({ data: { step: 1 } });
    navigate({ to: "/onboarding/provider" });
  };

  return (
    <div className="flex flex-col items-center text-center">
      <div className="mb-8">
        <div className="bg-primary text-primary-foreground mx-auto mb-6 flex size-20 items-center justify-center rounded-lg">
          <Zap className="size-10" />
        </div>
        <h1 className="mb-4 text-4xl font-bold tracking-tight">
          Welcome to quickprompt.dev
        </h1>
        <p className="text-muted-foreground text-xl">
          Get started with 3 free AI responses per day.
        </p>
      </div>

      <div className="mb-12 grid w-full max-w-4xl gap-4 md:grid-cols-3">
        <Card className="text-left">
          <CardHeader>
            <div className="bg-primary/10 mb-3 flex size-10 items-center justify-center rounded-lg">
              <Keyboard className="text-primary size-5" />
            </div>
            <CardTitle className="text-lg">Speed</CardTitle>
            <CardDescription>
              Instant streaming, keyboard-first navigation
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="text-left">
          <CardHeader>
            <div className="bg-primary/10 mb-3 flex size-10 items-center justify-center rounded-lg">
              <Key className="text-primary size-5" />
            </div>
            <CardTitle className="text-lg">Flexibility</CardTitle>
            <CardDescription>
              Add your own API key anytime for unlimited access
            </CardDescription>
          </CardHeader>
        </Card>

        <Card className="text-left">
          <CardHeader>
            <div className="bg-primary/10 mb-3 flex size-10 items-center justify-center rounded-lg">
              <BookOpen className="text-primary size-5" />
            </div>
            <CardTitle className="text-lg">Organization</CardTitle>
            <CardDescription>Your perfect prompts, never lost</CardDescription>
          </CardHeader>
        </Card>
      </div>

      <Button size="lg" onClick={handleGetStarted}>
        Get Started
      </Button>
    </div>
  );
}

export const Route = createFileRoute("/(authenticated)/onboarding/")({
  component: WelcomeScreen,
});
